(function(){
  function forceShowDialog() {
    var dialog = document.querySelector('.dialog-overlay');
    if (!dialog) return;
    
    var searchPopup = document.querySelector('#search_pupop.act_opened');
    var loginPopup = document.querySelector('#login_pupop.act_opened');
    var html = document.documentElement;
    
    if (searchPopup || loginPopup || 
        html.classList.contains('hside_opened') || 
        html.classList.contains('pside_opened')) {
      dialog.classList.add('force-visible');
      dialog.style.removeProperty('display');
      dialog.style.removeProperty('visibility');
      dialog.style.removeProperty('opacity');
      dialog.style.removeProperty('pointer-events');
      dialog.style.setProperty('display', 'flex', 'important');
    }
  }
  
  var _dialogObserver = new MutationObserver(function(mutations) {
    setTimeout(forceShowDialog, 5);
    mutations.forEach(function(m) {
      if (m.type === 'childList' && m.target && m.target.querySelector) {
        if (m.target.querySelector('.mini_cart_wrap')) {
          addCloseInstruction(m.target.closest('#search_pupop, #login_pupop') || m.target);
        }
      }
    });
  });
  _dialogObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'], subtree: true });
  
  document.addEventListener('DOMContentLoaded', function() {
    ['#search_pupop', '#login_pupop'].forEach(function(id) {
      var el = document.querySelector(id);
      if (el) {
        _dialogObserver.observe(el, { attributes: true, attributeFilter: ['class'], childList: true });
      }
    });
  });
  
  function addCloseInstruction(popup) {
    if (!popup || popup.querySelector('.search-close-instruction')) return;
    
    var wrap = popup.querySelector('.mini_cart_wrap');
    if (wrap) {
      var instruction = document.createElement('div');
      instruction.className = 'search-close-instruction';
      instruction.innerHTML = '<span>Tap here to close</span>';
      instruction.onclick = function() {
        popup.classList.remove('act_opened');
        document.documentElement.classList.remove('hside_opened', 'pside_opened');
        var dialog = document.querySelector('.dialog-overlay');
        if (dialog) dialog.classList.remove('force-visible');
        var mask = document.querySelector('.mask-overlay');
        if (mask) mask.classList.remove('mask_opened');
      };
      wrap.appendChild(instruction);
    }
  }
  
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.push_side[data-id="#search_pupop"], .push_side[data-id="#login_pupop"]');
    if (link) {
      e.preventDefault();
      e.stopPropagation();
      
      var targetId = link.getAttribute('data-id');
      var targetEl = document.querySelector(targetId);
      var dialog = document.querySelector('.dialog-overlay');
      var mask = document.querySelector('.mask-overlay');
      
      if (targetEl) {
        if (targetEl.classList.contains('act_opened')) {
          targetEl.classList.remove('act_opened');
          document.documentElement.classList.remove('hside_opened', 'pside_opened');
          if (dialog) dialog.classList.remove('force-visible');
          if (mask) mask.classList.remove('mask_opened');
          return false;
        }
        
        if (dialog) {
          dialog.classList.add('force-visible');
          dialog.style.setProperty('display', 'flex', 'important');
        }
        targetEl.classList.add('act_opened');
        document.documentElement.classList.add('hside_opened', 'pside_opened');
        if (mask) mask.classList.add('mask_opened');
        
        var includeUrl = targetEl.getAttribute('data-include');
        if (includeUrl && !targetEl.dataset.loaded) {
          fetch(includeUrl)
            .then(function(r) { return r.text(); })
            .then(function(html) {
              targetEl.innerHTML = html;
              targetEl.dataset.loaded = 'true';
              setTimeout(function() { addCloseInstruction(targetEl); }, 50);
            })
            .catch(function() {});
        } else {
          setTimeout(function() { addCloseInstruction(targetEl); }, 50);
        }
        
        if (targetId === '#search_pupop') {
          setTimeout(function() {
            var input = targetEl.querySelector('input[type="text"], input[type="search"]');
            if (input) input.focus();
          }, 100);
        }
      }
      
      return false;
    }
  }, true);
  
  document.addEventListener('click', function(e) {
    var isMask = e.target.classList.contains('mask-overlay');
    var isSearchBackground = e.target.id === 'search_pupop' && e.target.classList.contains('act_opened');
    var isCloseInstruction = e.target.closest('.search-close-instruction');
    
    if (isMask || isSearchBackground || isCloseInstruction) {
      var searchPopup = document.querySelector('#search_pupop.act_opened');
      var loginPopup = document.querySelector('#login_pupop.act_opened');
      var dialog = document.querySelector('.dialog-overlay');
      
      if (searchPopup) searchPopup.classList.remove('act_opened');
      if (loginPopup) loginPopup.classList.remove('act_opened');
      document.documentElement.classList.remove('hside_opened', 'pside_opened');
      if (dialog) dialog.classList.remove('force-visible');
      if (isCloseInstruction) e.preventDefault();
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var searchPopup = document.querySelector('#search_pupop.act_opened');
      var loginPopup = document.querySelector('#login_pupop.act_opened');
      var dialog = document.querySelector('.dialog-overlay');
      
      if (searchPopup || loginPopup) {
        if (searchPopup) searchPopup.classList.remove('act_opened');
        if (loginPopup) loginPopup.classList.remove('act_opened');
        document.documentElement.classList.remove('hside_opened', 'pside_opened');
        if (dialog) dialog.classList.remove('force-visible');
      }
    }
  });
})();
